import anime from 'animejs';
import Component, { forceArray } from 'navigation/component/Component';
import { EASE_IN, EASE_OUT, frameToMs } from 'helpers/easings';
import DragController from 'components/drag-controller/DragController';
import mqStore from 'store/mqStore';
import { bindMethod } from 'helpers/bind';
import store from 'store';
import { durations, pauseMotions } from './motion';
export default class MenuSecondPanelInner extends Component {
    mobile = false;
    motions = [];
    visible = false;
    initialized() {
        super.initialized();
        this.name = this.el.dataset.category || '';
    }
    getModulesMap() {
        return {
            pushes: ['.menu-pushes__horizontal', DragController]
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        mqStore.narrowDesktop.listenAndStart(this.onMqChange);
        this.refs.back[method]('click', () => this.onBack());
        store.subcategory.toggleListener(add, this.onSubCategoryUpdate);
        this.refs.links?.forEach((link) => {
            link[method]('click', this.onItemClick);
        });
    }
    onItemClick = (event) => {
        store.drawer.set(null);
    };
    onSubCategoryUpdate = (category) => {
        this.parent.category = category;
        const categoriesIncluded = this.refs.links?.map((link) => link.dataset.slug) || [];
        if (categoriesIncluded.includes(category)) {
            this.refs.links?.forEach((link) => {
                link.classList.remove('active');
                if (link.dataset.slug === category)
                    link.classList.add('active');
                else
                    link.classList.add('inactive');
            });
        }
        else {
            this.refs.links?.forEach((link) => {
                link.classList.remove('active');
                link.classList.remove('inactive');
            });
        }
    };
    onBack = () => {
        this.emit('category:back');
    };
    onMqChange = (mobile) => {
        this.mobile = mobile;
    };
    enter(reverse = false) {
        let m, m1;
        this.cancelMotions();
        if (!this.mobile) {
            this.el.classList.add('ready');
            m = anime({
                targets: [this.refs.links],
                begin: () => {
                    this.el.classList.remove('hiding');
                    this.el.classList.add('visible');
                    this.visible = true;
                },
                translateX: {
                    value: [-50, 0],
                    delay: anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER, { start: durations.FIRST_PANEL_TRANSLATE_OUT / 2 }),
                    duration: durations.SECOND_PANEL_ITEMS_TRANSLATE,
                    easing: EASE_OUT
                },
                opacity: {
                    value: [0, 1],
                    delay: anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER, { start: durations.SECOND_PANEL_ITEMS_OPACITY_IN_DELAY }),
                    duration: durations.SECOND_PANEL_ITEMS_OPACITY,
                    easing: 'linear'
                }
            });
            if (this.modules.pushes) {
                m1 = anime({
                    targets: [this.modules.pushes.refs.draggableItems],
                    opacity: {
                        value: [0, 1],
                        delay: anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER, { start: durations.SECOND_PANEL_ITEMS_OPACITY_IN_DELAY + this.refs.links.length * durations.SECOND_PANEL_ITEMS_STAGGER }),
                        duration: durations.SECOND_PANEL_ITEMS_OPACITY,
                        easing: 'linear'
                    }
                });
            }
        }
        else {
            m = anime({
                targets: [this.refs.back, this.refs.links],
                begin: () => {
                    this.el.classList.add('visible');
                    this.visible = true;
                },
                translateX: {
                    value: reverse ? [-50, 0] : [50, 0],
                    delay: anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { start: (frameToMs(12)) }),
                    duration: durations.SECOND_PANEL_MOBILE_ITEMS_TRANSLATE,
                    easing: EASE_OUT
                },
                opacity: {
                    value: [0, 1],
                    delay: anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { start: (frameToMs(12)) }),
                    duration: durations.SECOND_PANEL_MOBILE_ITEMS_OPACITY,
                    easing: 'linear'
                },
                complete: () => this.el.classList.add('ready')
            });
            if (this.modules.pushes) {
                m1 = anime({
                    targets: [this.modules.pushes.refs.draggableItems],
                    opacity: {
                        value: [0, 1],
                        delay: anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { start: (frameToMs(12)) + durations.SECOND_PANEL_MOBILE_ITEMS_TRANSLATE_IN_DELAY, from: this.refs.links.length + 1 }),
                        duration: durations.SECOND_PANEL_MOBILE_ITEMS_OPACITY,
                        easing: 'linear'
                    }
                });
            }
        }
        this.motions.push(m, m1);
    }
    leave(force = false) {
        let m, m1;
        this.cancelMotions();
        this.visible = false;
        this.el.classList.remove('ready');
        if (!this.mobile) {
            m = anime({
                targets: [this.refs.links],
                begin: () => {
                    this.el.classList.add('hiding');
                },
                translateX: {
                    value: [0, 50],
                    delay: force ? 0 : anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER),
                    duration: force ? 0 : durations.SECOND_PANEL_ITEMS_TRANSLATE,
                    easing: EASE_IN
                },
                opacity: {
                    value: [1, 0],
                    delay: force ? 0 : anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER),
                    duration: force ? 0 : durations.SECOND_PANEL_ITEMS_OPACITY,
                    easing: 'linear'
                },
                complete: () => {
                    this.el.classList.remove('visible');
                    this.el.classList.remove('hiding');
                    this.el.scrollTop = 0;
                }
            });
            if (this.modules.pushes) {
                m1 = anime({
                    targets: [this.modules.pushes.refs.draggableItems],
                    opacity: {
                        value: [1, 0],
                        delay: force ? 0 : anime.stagger(durations.SECOND_PANEL_ITEMS_STAGGER, { start: durations.SECOND_PANEL_ITEMS_OPACITY_IN_DELAY }),
                        duration: force ? 0 : durations.SECOND_PANEL_ITEMS_OPACITY,
                        easing: 'linear'
                    }
                });
            }
        }
        else {
            m = anime({
                targets: [this.refs.back, this.refs.links],
                translateX: {
                    value: [0, 50],
                    delay: force ? 0 : anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { direction: 'reverse' }),
                    duration: force ? 0 : durations.SECOND_PANEL_MOBILE_ITEMS_TRANSLATE,
                    easing: EASE_IN
                },
                opacity: {
                    value: [1, 0],
                    delay: force ? 0 : anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { direction: 'reverse' }),
                    duration: force ? 0 : durations.SECOND_PANEL_MOBILE_ITEMS_OPACITY,
                    easing: 'linear'
                },
                complete: () => {
                    this.el.classList.remove('visible');
                    this.el.scrollTop = 0;
                }
            });
            if (this.modules.pushes) {
                m1 = anime({
                    targets: [this.modules.pushes.refs.draggableItems],
                    opacity: {
                        value: [1, 0],
                        delay: anime.stagger(durations.SECOND_PANEL_MOBILE_ITEMS_STAGGER, { start: durations.SECOND_PANEL_MOBILE_ITEMS_OPACITY_IN_DELAY }),
                        duration: durations.SECOND_PANEL_MOBILE_ITEMS_OPACITY,
                        easing: 'linear'
                    }
                });
            }
        }
        this.motions.push(m, m1);
    }
    reset() {
        this.cancelMotions();
        this.el.classList.remove('visible', 'ready');
        this.visible = false;
        this.el.removeAttribute('style');
        forceArray(this.refs.links).forEach((link) => {
            link.removeAttribute('style');
        });
        if (this.modules.pushes) {
            forceArray(this.modules.pushes.refs.draggableItems).forEach((push) => {
                if (push)
                    push.style.opacity = '';
            });
        }
    }
    cancelMotions() {
        pauseMotions(this.motions);
        this.motions = [];
    }
}
